import { PROJECT_NAME } from '../../constants';

const PREFIX = `@${PROJECT_NAME}/Root`;

export const TOGGLE_MOBILE = `${PREFIX}/TOGGLE_MOBILE`;
export const SET_LANDING_DATA = `${PREFIX}/SET_LANDING_DATA`;

export const ALLOWED_LANGUAGES = ['en', 'fr', 'ru', 'zh', 'es'];
export const DEFAULT_LANGUAGE = 'en';
